<template>
  <div class="requisites">
    <div class="wrapper">
      <div class="requisites__inner">
        <div class="requisites__layout">
          <h3 class="requisites__item requisite">
            <span>Сбербанк :</span>
            <span>2202 2006 6893 6097</span>
            <span>или</span>
            <span>
              <a href="tel:+79857041207">+79857041207</a> (Лия Борисовна С.)
            </span>
          </h3>
          <h3 class="requisites__item requisite">
            <span>PayPal :</span>
            <a href="mailto:serafiminar@gmail.com">serafiminar@gmail.com</a>
          </h3>
          <h3 class="requisites__item requisite">
            <span>Bank of Georgia :</span>
            <span
              >NNLE Charity Foundation Seraphim GE47BG0000000162312295
              (Лари)</span
            >
          </h3>
          <h3 class="requisites__item requisite">
            <span>Яндекс-Деньги :</span>
            <a href="https://money.yandex.ru/to/410016214809684"
              >https://money.yandex.ru/to/410016214809684</a
            >
          </h3>
          <h3 class="requisites__item requisite">
            <span>Qiwi-кошелек :</span>
            <a href="tel:+79199681600">+79199681600</a>
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "requisites"
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.requisites {
  color: $sec_c;
  background-color: $aux_bg;

  &__layout {
    padding: 60px 0;
  }
}

.requisite {
  word-break: break-all;

  a {
    color: $sec_c;
  }

  @media screen and (min-width: $min_lg) {
    font-size: 24px;
  }

  @media screen and (max-width: $max_md) {
    font-size: 18px;
  }
}
</style>
